import {BackendOffDateOrderManager} from 'components/Backend/OffDateOrder/Manager';

export default BackendOffDateOrderManager;
export const orderNum = 6;
export const title = '訂單查詢';
